/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as RegistrationRouteRouteImport } from './pages/registration/route'
import { Route as landingRouteRouteImport } from './pages/(landing)/route'
import { Route as appRouteRouteImport } from './pages/(app)/route'
import { Route as RegistrationIndexRouteImport } from './pages/registration/index'
import { Route as landingIndexRouteImport } from './pages/(landing)/index'
import { Route as RegistrationSuccessRouteImport } from './pages/registration/success'
import { Route as InviteTokenRouteImport } from './pages/invite/$token'
import { Route as landingTermsRouteImport } from './pages/(landing)/terms'
import { Route as landingPrivacyRouteImport } from './pages/(landing)/privacy'
import { Route as InviteOnboardingIndexRouteImport } from './pages/invite/onboarding/index'
import { Route as authLoginIndexRouteImport } from './pages/(auth)/login/index'
import { Route as appOnboardingIndexRouteImport } from './pages/(app)/onboarding/index'
import { Route as appHomeIndexRouteImport } from './pages/(app)/home/index'
import { Route as appAccountIndexRouteImport } from './pages/(app)/account/index'
import { Route as authLoginConfirmRouteImport } from './pages/(auth)/login/confirm'
import { Route as appWishlistPartnerRouteImport } from './pages/(app)/wishlist/partner'
import { Route as appWishlistMeRouteImport } from './pages/(app)/wishlist/me'
import { Route as appOccasionsMeRouteImport } from './pages/(app)/occasions/me'
import { Route as appAccountPlanRouteImport } from './pages/(app)/account/plan'
import { Route as appAccountEditRouteImport } from './pages/(app)/account/edit'

const RegistrationRouteRoute = RegistrationRouteRouteImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => rootRouteImport,
} as any)
const landingRouteRoute = landingRouteRouteImport.update({
  id: '/(landing)',
  getParentRoute: () => rootRouteImport,
} as any)
const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationIndexRoute = RegistrationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RegistrationRouteRoute,
} as any)
const landingIndexRoute = landingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => landingRouteRoute,
} as any)
const RegistrationSuccessRoute = RegistrationSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => RegistrationRouteRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const landingTermsRoute = landingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => landingRouteRoute,
} as any)
const landingPrivacyRoute = landingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => landingRouteRoute,
} as any)
const InviteOnboardingIndexRoute = InviteOnboardingIndexRouteImport.update({
  id: '/invite/onboarding/',
  path: '/invite/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginIndexRoute = authLoginIndexRouteImport.update({
  id: '/(auth)/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const appOnboardingIndexRoute = appOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => appRouteRoute,
} as any)
const appHomeIndexRoute = appHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => appRouteRoute,
} as any)
const appAccountIndexRoute = appAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => appRouteRoute,
} as any)
const authLoginConfirmRoute = authLoginConfirmRouteImport.update({
  id: '/(auth)/login/confirm',
  path: '/login/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const appWishlistPartnerRoute = appWishlistPartnerRouteImport.update({
  id: '/wishlist/partner',
  path: '/wishlist/partner',
  getParentRoute: () => appRouteRoute,
} as any)
const appWishlistMeRoute = appWishlistMeRouteImport.update({
  id: '/wishlist/me',
  path: '/wishlist/me',
  getParentRoute: () => appRouteRoute,
} as any)
const appOccasionsMeRoute = appOccasionsMeRouteImport.update({
  id: '/occasions/me',
  path: '/occasions/me',
  getParentRoute: () => appRouteRoute,
} as any)
const appAccountPlanRoute = appAccountPlanRouteImport.update({
  id: '/account/plan',
  path: '/account/plan',
  getParentRoute: () => appRouteRoute,
} as any)
const appAccountEditRoute = appAccountEditRouteImport.update({
  id: '/account/edit',
  path: '/account/edit',
  getParentRoute: () => appRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/registration': typeof RegistrationRouteRouteWithChildren
  '/privacy': typeof landingPrivacyRoute
  '/terms': typeof landingTermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/registration/success': typeof RegistrationSuccessRoute
  '/': typeof landingIndexRoute
  '/registration/': typeof RegistrationIndexRoute
  '/account/edit': typeof appAccountEditRoute
  '/account/plan': typeof appAccountPlanRoute
  '/occasions/me': typeof appOccasionsMeRoute
  '/wishlist/me': typeof appWishlistMeRoute
  '/wishlist/partner': typeof appWishlistPartnerRoute
  '/login/confirm': typeof authLoginConfirmRoute
  '/account': typeof appAccountIndexRoute
  '/home': typeof appHomeIndexRoute
  '/onboarding': typeof appOnboardingIndexRoute
  '/login': typeof authLoginIndexRoute
  '/invite/onboarding': typeof InviteOnboardingIndexRoute
}
export interface FileRoutesByTo {
  '/privacy': typeof landingPrivacyRoute
  '/terms': typeof landingTermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/registration/success': typeof RegistrationSuccessRoute
  '/': typeof landingIndexRoute
  '/registration': typeof RegistrationIndexRoute
  '/account/edit': typeof appAccountEditRoute
  '/account/plan': typeof appAccountPlanRoute
  '/occasions/me': typeof appOccasionsMeRoute
  '/wishlist/me': typeof appWishlistMeRoute
  '/wishlist/partner': typeof appWishlistPartnerRoute
  '/login/confirm': typeof authLoginConfirmRoute
  '/account': typeof appAccountIndexRoute
  '/home': typeof appHomeIndexRoute
  '/onboarding': typeof appOnboardingIndexRoute
  '/login': typeof authLoginIndexRoute
  '/invite/onboarding': typeof InviteOnboardingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)': typeof appRouteRouteWithChildren
  '/(landing)': typeof landingRouteRouteWithChildren
  '/registration': typeof RegistrationRouteRouteWithChildren
  '/(landing)/privacy': typeof landingPrivacyRoute
  '/(landing)/terms': typeof landingTermsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/registration/success': typeof RegistrationSuccessRoute
  '/(landing)/': typeof landingIndexRoute
  '/registration/': typeof RegistrationIndexRoute
  '/(app)/account/edit': typeof appAccountEditRoute
  '/(app)/account/plan': typeof appAccountPlanRoute
  '/(app)/occasions/me': typeof appOccasionsMeRoute
  '/(app)/wishlist/me': typeof appWishlistMeRoute
  '/(app)/wishlist/partner': typeof appWishlistPartnerRoute
  '/(auth)/login/confirm': typeof authLoginConfirmRoute
  '/(app)/account/': typeof appAccountIndexRoute
  '/(app)/home/': typeof appHomeIndexRoute
  '/(app)/onboarding/': typeof appOnboardingIndexRoute
  '/(auth)/login/': typeof authLoginIndexRoute
  '/invite/onboarding/': typeof InviteOnboardingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/registration'
    | '/privacy'
    | '/terms'
    | '/invite/$token'
    | '/registration/success'
    | '/'
    | '/registration/'
    | '/account/edit'
    | '/account/plan'
    | '/occasions/me'
    | '/wishlist/me'
    | '/wishlist/partner'
    | '/login/confirm'
    | '/account'
    | '/home'
    | '/onboarding'
    | '/login'
    | '/invite/onboarding'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/privacy'
    | '/terms'
    | '/invite/$token'
    | '/registration/success'
    | '/'
    | '/registration'
    | '/account/edit'
    | '/account/plan'
    | '/occasions/me'
    | '/wishlist/me'
    | '/wishlist/partner'
    | '/login/confirm'
    | '/account'
    | '/home'
    | '/onboarding'
    | '/login'
    | '/invite/onboarding'
  id:
    | '__root__'
    | '/(app)'
    | '/(landing)'
    | '/registration'
    | '/(landing)/privacy'
    | '/(landing)/terms'
    | '/invite/$token'
    | '/registration/success'
    | '/(landing)/'
    | '/registration/'
    | '/(app)/account/edit'
    | '/(app)/account/plan'
    | '/(app)/occasions/me'
    | '/(app)/wishlist/me'
    | '/(app)/wishlist/partner'
    | '/(auth)/login/confirm'
    | '/(app)/account/'
    | '/(app)/home/'
    | '/(app)/onboarding/'
    | '/(auth)/login/'
    | '/invite/onboarding/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  landingRouteRoute: typeof landingRouteRouteWithChildren
  RegistrationRouteRoute: typeof RegistrationRouteRouteWithChildren
  InviteTokenRoute: typeof InviteTokenRoute
  authLoginConfirmRoute: typeof authLoginConfirmRoute
  authLoginIndexRoute: typeof authLoginIndexRoute
  InviteOnboardingIndexRoute: typeof InviteOnboardingIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/registration': {
      id: '/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof RegistrationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(landing)': {
      id: '/(landing)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof landingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration/': {
      id: '/registration/'
      path: '/'
      fullPath: '/registration/'
      preLoaderRoute: typeof RegistrationIndexRouteImport
      parentRoute: typeof RegistrationRouteRoute
    }
    '/(landing)/': {
      id: '/(landing)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof landingIndexRouteImport
      parentRoute: typeof landingRouteRoute
    }
    '/registration/success': {
      id: '/registration/success'
      path: '/success'
      fullPath: '/registration/success'
      preLoaderRoute: typeof RegistrationSuccessRouteImport
      parentRoute: typeof RegistrationRouteRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(landing)/terms': {
      id: '/(landing)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof landingTermsRouteImport
      parentRoute: typeof landingRouteRoute
    }
    '/(landing)/privacy': {
      id: '/(landing)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof landingPrivacyRouteImport
      parentRoute: typeof landingRouteRoute
    }
    '/invite/onboarding/': {
      id: '/invite/onboarding/'
      path: '/invite/onboarding'
      fullPath: '/invite/onboarding'
      preLoaderRoute: typeof InviteOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login/': {
      id: '/(auth)/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/onboarding/': {
      id: '/(app)/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof appOnboardingIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/home/': {
      id: '/(app)/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof appHomeIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/account/': {
      id: '/(app)/account/'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof appAccountIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(auth)/login/confirm': {
      id: '/(auth)/login/confirm'
      path: '/login/confirm'
      fullPath: '/login/confirm'
      preLoaderRoute: typeof authLoginConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/wishlist/partner': {
      id: '/(app)/wishlist/partner'
      path: '/wishlist/partner'
      fullPath: '/wishlist/partner'
      preLoaderRoute: typeof appWishlistPartnerRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/wishlist/me': {
      id: '/(app)/wishlist/me'
      path: '/wishlist/me'
      fullPath: '/wishlist/me'
      preLoaderRoute: typeof appWishlistMeRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/occasions/me': {
      id: '/(app)/occasions/me'
      path: '/occasions/me'
      fullPath: '/occasions/me'
      preLoaderRoute: typeof appOccasionsMeRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/account/plan': {
      id: '/(app)/account/plan'
      path: '/account/plan'
      fullPath: '/account/plan'
      preLoaderRoute: typeof appAccountPlanRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/account/edit': {
      id: '/(app)/account/edit'
      path: '/account/edit'
      fullPath: '/account/edit'
      preLoaderRoute: typeof appAccountEditRouteImport
      parentRoute: typeof appRouteRoute
    }
  }
}

interface appRouteRouteChildren {
  appAccountEditRoute: typeof appAccountEditRoute
  appAccountPlanRoute: typeof appAccountPlanRoute
  appOccasionsMeRoute: typeof appOccasionsMeRoute
  appWishlistMeRoute: typeof appWishlistMeRoute
  appWishlistPartnerRoute: typeof appWishlistPartnerRoute
  appAccountIndexRoute: typeof appAccountIndexRoute
  appHomeIndexRoute: typeof appHomeIndexRoute
  appOnboardingIndexRoute: typeof appOnboardingIndexRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appAccountEditRoute: appAccountEditRoute,
  appAccountPlanRoute: appAccountPlanRoute,
  appOccasionsMeRoute: appOccasionsMeRoute,
  appWishlistMeRoute: appWishlistMeRoute,
  appWishlistPartnerRoute: appWishlistPartnerRoute,
  appAccountIndexRoute: appAccountIndexRoute,
  appHomeIndexRoute: appHomeIndexRoute,
  appOnboardingIndexRoute: appOnboardingIndexRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface landingRouteRouteChildren {
  landingPrivacyRoute: typeof landingPrivacyRoute
  landingTermsRoute: typeof landingTermsRoute
  landingIndexRoute: typeof landingIndexRoute
}

const landingRouteRouteChildren: landingRouteRouteChildren = {
  landingPrivacyRoute: landingPrivacyRoute,
  landingTermsRoute: landingTermsRoute,
  landingIndexRoute: landingIndexRoute,
}

const landingRouteRouteWithChildren = landingRouteRoute._addFileChildren(
  landingRouteRouteChildren,
)

interface RegistrationRouteRouteChildren {
  RegistrationSuccessRoute: typeof RegistrationSuccessRoute
  RegistrationIndexRoute: typeof RegistrationIndexRoute
}

const RegistrationRouteRouteChildren: RegistrationRouteRouteChildren = {
  RegistrationSuccessRoute: RegistrationSuccessRoute,
  RegistrationIndexRoute: RegistrationIndexRoute,
}

const RegistrationRouteRouteWithChildren =
  RegistrationRouteRoute._addFileChildren(RegistrationRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  landingRouteRoute: landingRouteRouteWithChildren,
  RegistrationRouteRoute: RegistrationRouteRouteWithChildren,
  InviteTokenRoute: InviteTokenRoute,
  authLoginConfirmRoute: authLoginConfirmRoute,
  authLoginIndexRoute: authLoginIndexRoute,
  InviteOnboardingIndexRoute: InviteOnboardingIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
